import {
	Component,
	ComponentOptions,
	IComponentBindings,
	Initialization,
	QueryEvents
	} from 'coveo-search-ui';

export type DisplayAction = () => void;

export class SearchError extends Component {
	static ID = "SearchError";

	constructor(element: HTMLElement, options: ComponentOptions, bindings: IComponentBindings) {
		super(element, SearchError.ID, bindings);

		this.bind.onRootElement(QueryEvents.queryError, () => this.element.style.display = 'block');
		this.bind.onRootElement(QueryEvents.querySuccess, () => this.element.style.display = 'none');
	}
}

Initialization.registerAutoCreateComponent(SearchError);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/SearchError.ts